import React from "react";

import AspenAnimatedLogo from "./aspen_logo_animated.svg";

function AspenLogo(){
    return (
        <img src={AspenAnimatedLogo} alt="AspenLogo" />
    )
}

export default AspenLogo;